/** Assembles the consent body from the server-supplied statement plus the
 * privacy sentence. Returned as parts so the panel can render "Privacy Policy"
 * as a link — the one thing a plain server string cannot carry. Kept DOM-free
 * so it unit-tests.
 *
 * Only the privacy sentence is appended. It used to add "Tick this box to
 * receive these emails" too, which the statement now says itself, in the
 * direction that variant means: the opt-in asks you to tick to receive, the
 * soft opt-in tells you to tick to opt out. Appending the opt-in phrasing to
 * both told soft opt-in readers to do the opposite of what the box does. */

export const CONSENT_PRIVACY_PREFIX = "In line with our ";
export const CONSENT_PRIVACY_LINK = "Privacy Policy";
export const CONSENT_PRIVACY_SUFFIX = ".";

/** Absolute on purpose. The edge is served from id.<env>, so a relative
 * "/privacy" resolves against a host that has no such route — the link 404s
 * rather than reaching the policy. Same trap as the `next` param (see
 * README Gotchas). */
export const CONSENT_PRIVACY_URL =
  "https://help.muchbetteradventures.com/privacy-policy";

export interface ConsentBodyParts {
  lead: string;
  privacyPrefix: string;
  privacyLink: string;
  privacySuffix: string;
}

export function consentBodyParts(statement: string): ConsentBodyParts {
  return {
    lead: statement.trim(),
    privacyPrefix: CONSENT_PRIVACY_PREFIX,
    privacyLink: CONSENT_PRIVACY_LINK,
    privacySuffix: CONSENT_PRIVACY_SUFFIX,
  };
}
